import { LogInButton } from "./LogInButton";
import { ViewClaimStatusButton } from "./ViewClaimStatusButton";
import type { ActionButtonProps } from "./types";

export const ActionButton = ({ activeButtonOption }: ActionButtonProps) =>
  ({
    "view-claim-status": <ViewClaimStatusButton />,
    "your-account": <LogInButton labelKey="button_your_account" variant="secondary" />,
  }[activeButtonOption]);
